import { xhr as sdkXhr } from "coolremote-sdk";

/**
 * Tracks whether the SDK's in-memory token currently holds one of this
 * wizard's own temporary tokens (set by `callSubmitProfessionalRegistration`
 * or `existingUserFlowApi`'s `login`), as opposed to a real logged-in user's
 * session token. `sdkXhr` is a single global client shared by the whole app,
 * so clearing its token must never happen unconditionally.
 */
let hasPendingPublicRegistrationToken = false;

export const markPublicRegistrationTokenSet = (): void => {
  hasPendingPublicRegistrationToken = true;
};

export const clearPublicRegistrationTokenFlag = (): void => {
  hasPendingPublicRegistrationToken = false;
};

/**
 * Clears the SDK's in-memory token, but only if it's a stale token left
 * over from an abandoned registration attempt. Call this on every mount of
 * the wizard's entry step, so a technician who backs out mid-flow and
 * restarts doesn't have that earlier attempt's token silently attached to
 * the next attempt's calls.
 */
export const clearStalePublicRegistrationToken = (): void => {
  if (!hasPendingPublicRegistrationToken) {
    return;
  }
  sdkXhr.setToken("");
  hasPendingPublicRegistrationToken = false;
};
